// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1oJLx","alertIcon":"ConfirmModal_alertIcon__2Luh9"};